"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.12)',
      border: 'solid 1px var(--Tundora-20)',
      backgroundColor: 'var(--White)',
      position: 'absolute',
      top: 46,
      right: "-".concat(theme.spacing(1)),
      borderRadius: 5
    },
    wrapper: {
      overflowY: 'auto',
      width: 350,
      maxHeight: 476,
      padding: theme.spacing(0, 2)
    },
    dataLabel: {
      cursor: 'pointer',
      marginBottom: theme.spacing(2)
    },
    divider: {
      borderTop: "1px solid ".concat(theme.palette.divider),
      width: '100%',
      marginBottom: theme.spacing(2)
    },
    arrow: {
      width: 20,
      height: 20,
      background: 'inherit',
      position: 'absolute',
      right: 20,
      top: -10,
      border: '1px solid #e6e6e6',
      borderBottom: 'none',
      borderRight: 'none',
      transform: 'rotate(45deg)'
    }
  };
});
/**
 * @callback onInsertCustomData
 * @param {string} value
 * @returns {undefined}
 */

/**
 * Custom data wrapper.
 *
 * @deprecated
 *
 * @function
 * @param {object} props
 * @param {Array<{ value: ?string, label: string, property: string }>} props.customData
 * @param {onInsertCustomData} props.onInsertCustomData
 *
 * @returns {React.ForwardRefRenderFunction}
 */

var CustomDataWrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var customData = _ref.customData,
      onInsertCustomData = _ref.onInsertCustomData;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "Label-Table-Left-Static"
  }, "FIELD")), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: "Label-Table-Left-Static"
  }, "PREVIEW")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divider
  }), customData.map(function (data) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: data.label
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      key: data.label,
      onClick: function onClick() {
        onInsertCustomData(data.value || data.property);
      },
      className: (0, _classnames["default"])(classes.dataLabel, 'Body-Regular-Left-ALL-CAP-LINK-Bold')
    }, data.label)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, data.value || data.property)));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.arrow
  }));
});

CustomDataWrapper.propTypes = {
  customData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string.isRequired,
    property: _propTypes["default"].string.isRequired
  })).isRequired,
  onInsertCustomData: _propTypes["default"].func.isRequired
};
var _default = CustomDataWrapper;
exports["default"] = _default;